import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE_TOKEN: `${cleanedFilename(__filename)}-delete-token`,
};
